import { CentumVP } from 'components/hmilib/hooks/CentumVPScript';
import React, { useCallback, useEffect, useState } from 'react';
import TreeAPC, { ITreeAPC_branch } from '../CentumTree/CentumTree';
import './overview.css';
import OverviewBottom from './OverviewBottom';
// import { ContextMenu } from 'components/MainControl/Settings/components/ContextMenu/ContextMenu';

interface IOverview {
    dataTree: any;
    dataTrendsTree: any;
    selectedElem: string;
    style?: React.CSSProperties;
    callbackSelectedElem?: (id: string) => void;
}

interface IState {
    openWindowTree: boolean;
    tree: ITreeAPC_branch[];
    trendTree: ITreeAPC_branch[];
    resizeTree: boolean;
    resizeMDPoint?: number;
    widthWindowTree?: number;
    selectedElem?: string;
}

const Overview = (props: IOverview) => {
    const [treeState, setTreeState] = useState<IState>({
        openWindowTree: true,
        tree: [],
        trendTree: [],
        resizeTree: false,
        resizeMDPoint: 0,
        widthWindowTree: 300,
        selectedElem: props.selectedElem
    });

    const [contextMenu, setContextMenu] = useState({
        visible: false,
        x: 0,
        y: 0
    });

    const [treeHeight, setTreeHeight] = useState<number>(70);
    const [bottomHeight, setBottomHeight] = useState<number>(30);
    const [resizing, setResizing] = useState<boolean>(false);
    const [initialY, setInitialY] = useState<number | null>(null);

    useEffect(() => {
        let updatedTrees: any = [];
        let updatedTrendTrees: any = [];

        if (props.dataTree != undefined) updatedTrees = props.dataTree.map(updateConf);

        if (props.dataTrendsTree != undefined) updatedTrendTrees = props.dataTrendsTree.map(updateConfTrend);

        setTreeState((prevState) => ({
            ...prevState,
            tree: [...updatedTrees],
            trendTree: [...updatedTrendTrees]
        }));

        // SetLoad();
    }, [props.dataTree, props.dataTrendsTree]);

    const resizeWidthWindow = (e: React.MouseEvent) => {
        let width: number = e.pageX - 23;
        if (width > 150 && width < 750 && treeState.resizeTree) {
            setTreeState((prevState) => ({ ...prevState, widthWindowTree: width }));
        }
    };

    const selectClick = (name: string) => {
        setTreeState((prevState) => ({ ...prevState, selectedElem: name }));
        if (props.callbackSelectedElem != undefined) {
            props.callbackSelectedElem(name);
        }
    };

    const isEmpty = (obj: any) => {
        for (let key in obj) {
            return false;
        }
        return true;
    };

    const updateConf = (obj: any) => {
        let tempName;

        if (obj.name === 'MNEMONICDIAGRAMFOLDER') {
            tempName = 'USER';
            obj.icon = '/ixyber/vision/static/images/tree_icon/centum_user_icon.jpg';
        } else if (obj.subname === null || obj.subname === '' || obj.subname === undefined) {
            tempName = obj.name;
        } else {
            tempName = obj.subname;
        }

        let branch: ITreeAPC_branch = {
            name: tempName,
            type: 'folder',
            path: obj.path,
            iconUrl:
                obj.icon === `MNEMO.svg` ? '/ixyber/vision/static/images/tree_icon/centum_mnemo_icon.jpg' : obj.icon,
            children: [],
            clickCallBack: () => {
                if (obj.description === 'alarm') {
                    CentumVP.process_alarm_open(obj.name);
                } else {
                    if (obj.subname.includes('Block') && obj.subname.includes('Group')) {
                        const fullPath = obj.file;
                        const fileNameWithExtension = fullPath.split(/[/\\]/).pop();
                        const fileName = fileNameWithExtension.split('.')[0];

                        window.OpenMnemo(`${fileName}?${obj.parameters}`);
                    } else {
                        window.OpenMnemo(`${obj.name}?parentpath=${obj.path}?id=${obj.id}`);
                        selectClick(`?pid=${obj.pid}?id=${obj.id}`);
                    }
                }
            }
        };

        for (let mKey in obj.mnemonicDiagrams) {
            let mBranch: ITreeAPC_branch = {
                name:
                    obj.mnemonicDiagrams[mKey].subname === null ||
                    obj.mnemonicDiagrams[mKey].subname === undefined ||
                    obj.mnemonicDiagrams[mKey].subname === ''
                        ? obj.mnemonicDiagrams[mKey].name
                        : obj.mnemonicDiagrams[mKey].subname,
                type: 'file',
                path: obj.mnemonicDiagrams[mKey].path,
                // iconUrl: '/ixyber/vision/static/images/tree_icon/centum_mnemo_icon.jpg',
                iconUrl:
                    obj.mnemonicDiagrams[mKey].icon === `MNEMO.svg`
                        ? '/ixyber/vision/static/images/tree_icon/centum_mnemo_icon.jpg'
                        : obj.mnemonicDiagrams[mKey].icon,
                children: [],
                clickCallBack: () => {
                    if (obj.mnemonicDiagrams[mKey].description === 'alarm') {
                        // if(props.callbackSelectedAlarm) { props.callbackSelectedAlarm(obj.mnemonicDiagrams[mKey].name) }
                        CentumVP.process_alarm_open(obj.mnemonicDiagrams[mKey].name);
                    } else {
                        if (
                            obj.mnemonicDiagrams[mKey].subname.includes('Block') &&
                            obj.mnemonicDiagrams[mKey].subname.includes('Group')
                        ) {
                            const fullPath = obj.mnemonicDiagrams[mKey].file;
                            const fileNameWithExtension = fullPath.split(/[/\\]/).pop();
                            const fileName = fileNameWithExtension.split('.')[0];

                            window.OpenMnemo(`${fileName}?${obj.mnemonicDiagrams[mKey].parameters}`);
                        } else {
                            window.OpenMnemo(
                                `${obj.mnemonicDiagrams[mKey].name}?parentpath=${obj.path}?id=${obj.mnemonicDiagrams[mKey].id}`
                            );
                            selectClick(`?pid=${obj.mnemonicDiagrams[mKey].pid}?id=${obj.mnemonicDiagrams[mKey].id}`);
                        }
                    }
                }
            };

            if (!isEmpty(obj.mnemonicDiagrams[mKey].mnemonicDiagrams)) {
                let temp = updateConf(obj.mnemonicDiagrams[mKey]);
                branch.type = 'folder';
                if (branch.children !== undefined) {
                    branch.children.push(temp);
                }
            } else {
                if (branch.children !== undefined) {
                    branch.children.push(mBranch);
                }
            }
        }
        return branch;
    };

    function isEmptyObject(obj: any) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    // let menuItems: any = [];
    const [menuItems, setMenuItems] = React.useState<any[]>([]);

    const updateConfTrend = (obj: any) => {
        let icon = '/ixyber/vision/static/images/tree_icon/trend_folder.png';

        let branch: ITreeAPC_branch = {
            name: obj.name,
            type: 'folder',
            path: obj.path,
            iconUrl: icon,
            children: []
        };

        for (let mKey in obj.blocks) {
            let TagName: string = '';
            let PARAM: string = '';

            if (obj.blocks[mKey].bindinglist) {
                obj.blocks[mKey].bindinglist.map((item: any, index: number) => {
                    if (item.name == 'TAG') {
                        TagName = item.Value;
                    }
                    if (item.name == 'PARAM') {
                        PARAM = item.Value;
                    }
                });
            } else {
                TagName = obj.blocks[mKey].name;
            }

            let name = obj.blocks[mKey].bindinglist ? `${TagName}.${PARAM}` : `${TagName}`;

            if (obj.blocks[mKey].type == 'BLOCKVP' || obj.type == 'BLOCKVP') {
                // icon = '/ixyber/vision/static/images/tree_icon/trend_folder.png';
                name = obj.blocks[mKey].name;
            } else {
                icon = '/ixyber/vision/static/images/tree_icon/trend_pen.png';
            }

            let mBranch: ITreeAPC_branch = {
                name: name,
                type: 'file',
                path: obj.blocks[mKey].path,
                iconUrl: icon,
                children: [],
                clickCallBack: () => {
                    window.OpenFaceplate(TagName);
                },
                contextCallBack: (ev: React.MouseEvent) => {
                    ev.preventDefault();
                    setContextMenu({
                        visible: true,
                        x: ev.pageX,
                        y: ev.pageY
                    });

                    setMenuItems([
                        {
                            icon: 'fa fa-faceplate',
                            label: 'Face Plate (P)',
                            action: () => window.OpenFaceplate(TagName)
                        },
                        { icon: 'fa fa-tuning', label: 'Tuning (W)', action: () => window.OpenFaceplateTun(TagName) },
                        { icon: 'fa fa-alarm', label: 'Process Alarm (L)', action: () => {} },
                        { icon: 'fa fa-trend', label: 'Trend (T)', action: () => CentumVP.trends_find_group(TagName) },
                        // { icon: "fa fa-trend", label: "Trend (T)", action: () => window.CentumVP.trends_open({ name: `centumtrends`, item: nameParam }) },
                        { icon: 'fa fa-control', label: 'Control (C)', action: () => {} },
                        { icon: 'fa fa-graphic', label: 'Graphic (G)', action: () => {} }
                    ]);
                }
            };

            if (!isEmpty(obj.blocks[mKey].blocks)) {
                let temp = updateConfTrend(obj.blocks[mKey]);
                branch.type = 'folder';
                if (branch.children !== undefined) {
                    branch.children.push(temp);
                }
            } else {
                if (branch.children !== undefined) {
                    branch.children.push(mBranch);
                }
            }
        }
        return branch;
    };

    const tabs = ['View', 'Trend', 'Plant'];
    const [activeTab, setActiveTab] = useState<string>(tabs[0]);

    const handleArrowClick = (position: string) => {
        const currentIndex = tabs.indexOf(activeTab);
        let newIndex: number = currentIndex;

        if (position === 'left') {
            newIndex = currentIndex === 0 ? 0 : currentIndex - 1;
        } else if (position === 'right') {
            newIndex = currentIndex === tabs.length - 1 ? tabs.length - 1 : currentIndex + 1;
        }

        setActiveTab(tabs[newIndex]);
    };

    // изменение размера контейнера дерева
    React.useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (!resizing) return;

            if (initialY !== null && resizing) {
                const container = document.querySelector('.overview-main');
                if (container) {
                    const deltaY = e.clientY - initialY;
                    const percentageChange = (deltaY / container?.clientHeight) * 100;
                    // Ограничение по высоте
                    const newTreeHeight = Math.min(Math.max(treeHeight + percentageChange, 0), 90);
                    const newBottomHeight = Math.min(Math.max(bottomHeight - percentageChange, 10), 100);

                    setTreeHeight(newTreeHeight);
                    setBottomHeight(newBottomHeight);
                    setInitialY(e.clientY);
                }
            }
        };

        const handleMouseUp = () => {
            if (resizing) {
                setResizing(false);
            }
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [initialY, resizing, treeHeight, bottomHeight]);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        setResizing(true);
        setInitialY(e.clientY);
    };

    const [leafName, setLeafName] = React.useState<string>('');
    const [leafPath, setLeafPath] = React.useState<string>('');

    // Сохраняем name и path при наведении на элемент в дереве
    const selectedLeaf = useCallback((name: string, path: string) => {
        setLeafName(name);
        setLeafPath(path);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (contextMenu.visible && event.target.id !== 'menucontext-trends') {
                setContextMenu({
                    visible: false,
                    x: 0,
                    y: 0
                });
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [contextMenu]);

    return (
        <div style={props.style}>
            <div className="centumvp_left_panel_main_name">
                <h3
                    style={{
                        color: '#ffffff',
                        height: '25px',
                        margin: '0px',
                        fontSize: '1rem',
                        paddingLeft: '10px',
                        userSelect: 'none'
                    }}>
                    Overview
                </h3>
                <div className="centumvp_left_panel_main_tab">
                    <svg
                        width="20px"
                        height="20px"
                        viewBox="-3 2 16 16"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleArrowClick('left')}>
                        <polygon points="10 4 2 10 10 16" stroke="#7d858d" strokeWidth="1"></polygon>
                    </svg>
                    <svg
                        width="20px"
                        height="20px"
                        viewBox="3 2 16 16"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleArrowClick('right')}>
                        <polygon points="6 4 14 10 6 16" stroke="#7d858d" strokeWidth="1"></polygon>
                    </svg>
                    {tabs.map((tab) => (
                        <div
                            key={tab}
                            className={activeTab === tab ? 'active' : ''}
                            style={{ fontFamily: 'Roboto' }}
                            onClick={() => setActiveTab(tab)}>
                            {tab}
                        </div>
                    ))}
                </div>
            </div>
            <div className="overview-main" style={{ marginTop: '2%', height: 'calc(100% - 60px)' }}>
                <div
                    className="overvie-main__tree"
                    style={{ height: `${treeHeight}%`, border: '1px solid', borderColor: '#808080 #fff #fff #808080' }}>
                    <div className="overview-main__tree-window">
                        <div style={{ display: activeTab === 'View' ? '' : 'none' }}>
                            <TreeAPC inpArr={treeState.tree} selectedLeaf={selectedLeaf} />
                        </div>
                        <div style={{ display: activeTab === 'Trend' ? '' : 'none' }}>
                            <TreeAPC inpArr={treeState.trendTree} selectedLeaf={selectedLeaf} />
                            {contextMenu.visible && (
                                <div
                                    id="menucontext-trends"
                                    className="centumvp_menucontext"
                                    style={{
                                        position: 'fixed',
                                        background: '#d3cfcb',
                                        zIndex: 9999,
                                        top: `${contextMenu.y}px`,
                                        left: `${contextMenu.x}px`
                                    }}>
                                    <nav className="centumvp_context-menu">
                                        <ul className="centumvp_context-menu__items">
                                            {menuItems.map((item: any, index: any) => (
                                                <li
                                                    key={index}
                                                    className="centumvp_context-menu__item"
                                                    onClick={item.action}>
                                                    <i className={item.icon}>{item.label}</i>
                                                </li>
                                            ))}
                                            {/* <hr className="centumvp_context-menu__line" /> */}
                                        </ul>
                                    </nav>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className="overview-main__resizer"
                    style={{ width: '100%', height: '1%', cursor: 'ns-resize' }}
                    onMouseDown={handleMouseDown}></div>

                <OverviewBottom leafName={leafName} leafPath={leafPath} bottomHeight={bottomHeight} />
            </div>
        </div>
    );
};

export default Overview;
